<template>
  <div class="modal fade show custom-modal" id="quoteGenerated" :class="{'modal-show':showModal}">
    <div class="modal-dialog modal-dialog-centered model-lg">
      <div class="modal-content">
        <div class="modal-head d-flex">
          <img src="@/assets/images/done.png" class="tick border-0 position-relative mt-3" />
        </div>
        <div class="modal-body text-center position-relative mt-2">
          <p class="text-center mb-0 mt-1">Your quote has been</p>
          <p class="text-center mb-0">successfully generated with </p>
          <p class="text-center mb-0"><span class="font-weight-bold" v-if="completedb.crossReferenceNo">Common Reference Number : {{completedb.crossReferenceNo}}</span>
           <span v-if="completedb.crossReferenceNo"> and </span></p>
          <p class="text-center font-weight-bold ">Quote ID : {{completedb.quoteId}}</p>
        </div>
        <div class="text-center d-flex justify-content-center mb-5">
          <button type="button" @click="hideModal()" class="btn bgc-btn-primary w-25" data-dismiss="modal" id="quote-generated-done">Done</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "QuoteGeneratedModal",
  props: ["completedb", "showModal"],
  setup(props,context){
    function hideModal(){
      context.parent.hideModal();
    }
    return{
       hideModal
    }
  }
};
</script>

<style scoped>
.custom-modal {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
  transform: scale(0);
}
.modal-show {
  display: block;
  transform: scaleY(0) scaleX(0);
  animation: unfoldIn 0.25s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
.modal-head{
    -ms-flex-negative:0;
    flex-shrink:0;
    margin: 28px 5px 12px 5px;
    justify-content:space-between;
}
.modal-body {
  overflow-y: hidden;
}
.btn:hover {
  color: #ffffff;
}
.tick {
  color: white;
  width: 50px;
  height: 50px;
  left: 46%;
}
</style>